/**
 * Scroll the quote request form into view if it's not already.
 *
 * @depends moveTo.js
 */
function scrollForm(formElement) {
	let targetElement = formElement;

	const anchor = document.querySelector('.quote_form_anchor');
	const rebrandAnchor = document.querySelector('.js-rebrand-quote-form-anchor');

	let tolerance = -12;

	if (anchor) {
		targetElement = anchor;
	} else if (rebrandAnchor) {
		targetElement = rebrandAnchor;
		formElement = targetElement;
		tolerance = getHeaderHeight() + 12;
	}

	// Scroll up only if the form *itself* is obscured by the header (or above the viewport).
	if (isElementObscuredByHeader(formElement)) {
		const y = targetElement.getBoundingClientRect().top + window.scrollY - tolerance;

		console.log('Scrolling quote request form into place...');
		window.scrollTo({
			top: y,
			behavior: 'smooth',
		});
	}
}

function getHeaderHeight() {
	const headerElement = document.querySelector('.js-header');

	if (headerElement) {
		return headerElement.offsetHeight;
	}

	return 0;
}

function isElementObscuredByHeader(element) {
	const headerHeight = getHeaderHeight();
	const boundingRectangle = element.getBoundingClientRect();

	// Element is technically in the viewport but hidden behind the sticky header
	return boundingRectangle.top < headerHeight;
}

export {
	scrollForm
}